let controller = null;
let pendingOpen = null;

const fileViewerService = {
    install(Vue) {
        Vue.prototype.$fileViewer = fileViewerService;
    },

    register(instance) {
        controller = instance;
        if (pendingOpen) {
            const next = pendingOpen;
            pendingOpen = null;
            controller.open(next.files, next.options);
        }
    },

    unregister(instance) {
        if (controller === instance) {
            controller = null;
        }
    },

    open(files, options = {}) {
        if (!controller) {
            pendingOpen = {files, options};
            return;
        }
        controller.open(files, options);
    },

    close() {
        if (controller) {
            controller.close();
        }
    },

    isOpen() {
        return Boolean(controller && controller.isOpen);
    }
};

export default fileViewerService;
